import { publicAssetsURL } from '#internal/nuxt/paths';export default publicAssetsURL("/images/sections/about/videoframe_0.webp")